import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PROFILE_ROUTES } from 'utils/routes';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import TopicList from '../browse/TopicList';
import BillboardAndCarousel from './BillboardAndCarousel';
import CollectionCarousel from './CollectionCarousel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function HomeSection(_ref) {
  var _data$featured, _data$upcoming, _data$shared, _data$trending, _data$recommendations, _data$recentlyViewed, _data$recentlyAdded;
  var id = _ref.id,
    isFirstCarousel = _ref.isFirstCarousel,
    data = _ref.data;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function renderCarouselSection(heading, items, options) {
    return /*#__PURE__*/_jsxs(PageSection, {
      "aria-labelledby": id,
      children: [options !== null && options !== void 0 && options.viewAllTo ? /*#__PURE__*/_jsxs(Flex, {
        align: "center",
        justifyContent: "space-between",
        mb: "s",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          size: "large",
          id: id,
          children: heading
        }), /*#__PURE__*/_jsx(Button, {
          round: true,
          iconRight: "arrow-right",
          variant: "shaded",
          as: NavLink,
          to: options.viewAllTo,
          children: t('actions_view_all')
        })]
      }) : /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        size: "large",
        id: id,
        mb: "s",
        children: heading
      }), isFirstCarousel ? /*#__PURE__*/_jsx(BillboardAndCarousel, {
        items: items,
        labelId: id,
        isShared: options === null || options === void 0 ? void 0 : options.isShared
      }) : /*#__PURE__*/_jsx(CollectionCarousel, {
        items: items,
        labelId: id,
        isShared: options === null || options === void 0 ? void 0 : options.isShared
      })]
    });
  }
  switch (id) {
    case 'featured':
      return renderCarouselSection(t('featured_content_title'), (_data$featured = data.featured) !== null && _data$featured !== void 0 ? _data$featured : []);
    case 'upcoming':
      return renderCarouselSection(t('upcoming_title'), (_data$upcoming = data.upcoming) !== null && _data$upcoming !== void 0 ? _data$upcoming : [], {
        viewAllTo: PROFILE_ROUTES.upcoming
      });
    case 'shared':
      return renderCarouselSection(t('shared_with_you'), (_data$shared = data.shared) !== null && _data$shared !== void 0 ? _data$shared : [], {
        isShared: true
      });
    case 'topics':
      return /*#__PURE__*/_jsxs(PageSection, {
        "aria-labelledby": id,
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          size: "large",
          id: id,
          mb: "s",
          children: t('content_type_topic_plural')
        }), /*#__PURE__*/_jsx(TopicList, {
          withBrowseButton: true,
          items: data.topics,
          variant: data.topicsDisplayType
        })]
      });
    case 'trending':
      return renderCarouselSection(t('trending_title'), (_data$trending = data.trending) !== null && _data$trending !== void 0 ? _data$trending : []);
    case 'recommendations':
      return renderCarouselSection(t('you_might_like_title'), (_data$recommendations = data.recommendations) !== null && _data$recommendations !== void 0 ? _data$recommendations : []);
    case 'recentlyViewed':
      return renderCarouselSection(t('recently_viewed_title'), (_data$recentlyViewed = data.recentlyViewed) !== null && _data$recentlyViewed !== void 0 ? _data$recentlyViewed : []);
    case 'recentlyAdded':
      return renderCarouselSection(t('recently_added_title'), (_data$recentlyAdded = data.recentlyAdded) !== null && _data$recentlyAdded !== void 0 ? _data$recentlyAdded : []);
    default:
      return null;
  }
}
export default HomeSection;